module.exports = __webpack_public_path__ + "img/ico-checked-18.68ed5a23.svg";